import type { IApiProxy } from '@erp/native/interfaces';

export function createWebApiProxy(): IApiProxy {
  return {
    async fetch(req) {
      const res = await fetch(req.path, {
        method: req.method ?? 'GET',
        headers: Object.fromEntries(req.headers ?? []),
        body: req.body ?? undefined,
      });

      return {
        status: res.status,
        statusText: res.statusText,
        headers: Array.from(res.headers.entries()),
        body: await res.text(),
      };
    },
  };
}
